import React, { useEffect, useState } from 'react';
import mapFieldsToData from '../../helpers/mapFieldsToData';
import http from '../../service'
import ListPage from '../../Components/ListPage';
import WaterBoxIcon from '../../images/WaterBoxIcon';
import * as S from './WaterTanks.style';
import * as constants from './WaterTanks.constants';

export default function WaterTanks ({ setModal }) {
  const { waterTanksSearchFieldsState, waterTanksSearchFields } = constants;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [page, setPage] = useState(1);
  const [list, setList] = useState([]);
  const [totalPages, setTotalPages] = useState('');
  const [totalCount, setTotalCount] = useState('');
  const [fields, setFields] = useState(waterTanksSearchFieldsState);
  const searchFields = waterTanksSearchFields({fields});
  const url = 'watertank'
  const listPageObject = {
    ...constants, loading, error, page, totalPages, totalCount, list, fields: searchFields, url, setModal,
    setLoading, setError, setPage, setTotalPages, setTotalCount, icon: WaterBoxIcon, setList, setFields, 
  }

  useEffect(() => {
    const query = searchFields.query.value;
    http.get(url).then(({ data }) => setList(data.data.filter((item) => item.name.toLowerCase().includes(query.toLowerCase()))))
      .catch((err) => setError(err))
  }, [searchFields.query.value])

  return (
    <S.WaterTanks>
      <ListPage {...listPageObject} />
    </S.WaterTanks>
  );
};
